import { render, staticRenderFns } from "./TakipEkAlanList.vue?vue&type=template&id=07a9319a"
import script from "./TakipEkAlanList.vue?vue&type=script&lang=ts"
export * from "./TakipEkAlanList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports